import { Injectable } from "@angular/core";
import { CryptoHelper } from "../../shared/helpers/crypto.helper";
import { StringUtilsHelper } from "../../shared/helpers/strings.helper";
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root'
})
export class LocalConfigService {

    saveElement(key: string, data: any): void {
        //let valueEncryp = StringUtilsHelper.notNullOrUndefinedOrEmpty(data) ? CryptoHelper.encrypt(data) : "";
        localStorage.setItem(key, data);
    }
    getElement(key: string): any {
        let value = localStorage.getItem(key);
        return value;
        /* if(StringUtilsHelper.notNullOrUndefinedOrEmpty(value)){
            return CryptoHelper.decrypt(value);
        }
        return ""; */
    }
    removeElement(key: string){
        localStorage.removeItem(key);
    }
    removeAll(){
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem("sanetId", uuidv4());
    }

    saveElementJson(key: string, data: any): void {
      const value = data ? JSON.stringify(data) : ""; // Convierte a JSON solo si no está vacío
      localStorage.setItem(key, value); // Guarda la cadena JSON
  }

    getElementJson(key: string): any {
        const value = localStorage.getItem(key); // Recupera la cadena JSON
        return value ? JSON.parse(value) : null; // Convierte de JSON a objeto si no está vacío
    }

    saveOnSessionElementJson(key: string, data: any): void {
      const value = data ? JSON.stringify(data) : ""; // Convierte a JSON solo si no está vacío
      sessionStorage.setItem(key, value); // Guarda la cadena JSON
    }

    getOnSessionElementJson(key: string): any {
        const value = sessionStorage.getItem(key); // Recupera la cadena JSON
        return value ? JSON.parse(value) : null; // Convierte de JSON a objeto si no está vacío
    }
}
